import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { useListSaleOfCustomer } from "hooks";
import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import useTable from "./useTable";

const initParams = {
  page: 1,
  sizePerPage: 10,
  columnFilter: {
    "filter[record_status]": "O",
    "filter[customer_id]": undefined,
  },
  run: false,
  expand: "sale",
};

const SaleSupport = ({ customerId, isOpenSaleSupport, toggleSaleSupport }) => {
  const [params, setParams] = useState(initParams);
  const { columnTable, onTableChange, onSearchAllHandle } = useTable({
    params,
    setParams,
  });

  const {
    data: saleOfCustomer,
    refetch: fetchSaleOfCustomer,
    isLoading,
  } = useListSaleOfCustomer({ params });

  useEffect(() => {
    if (customerId && isOpenSaleSupport) {
      setParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          "filter[customer_id]": customerId,
        },
        run: true,
      }));
    }
  }, [customerId, isOpenSaleSupport]);

  useEffect(() => {
    if (params.run) {
      fetchSaleOfCustomer();
    }
  }, [params]);

  const handleToggelModal = () => {
    setParams(initParams);
    toggleSaleSupport();
  };

  return (
    <Modal
      size="lg"
      role="dialog"
      autoFocus={true}
      centered={true}
      isOpen={isOpenSaleSupport}
      toggle={handleToggelModal}
    >
      <ModalHeader toggle={handleToggelModal}>Sale phụ trách</ModalHeader>
      <ModalBody>
        <RemoteDataTable
          keyField="id"
          data={saleOfCustomer?.items || []}
          columns={columnTable}
          page={params.page}
          sizePerPage={params.sizePerPage}
          totalSize={saleOfCustomer?.totalCount || 0}
          onTableChange={onTableChange}
          onSearchAllHandle={onSearchAllHandle}
          loading={isLoading}
        ></RemoteDataTable>
      </ModalBody>
    </Modal>
  );
};

export default SaleSupport;
